<div class="h-full min-h-0" *transloco="let t">
  <app-form-shell>
    <div shellHeader>
      <IStepper [steps]="formSteps()" [form]="creationForm" (stepSelect)="goToStep($event)" clickable />
    </div>
    <div shellMain class="h-full min-h-0">
      @switch (currentStepId()) {
        @case ("setup") {
          <app-sd-create-strategy-setup [setup]="creationForm.setup" />
        }
        @case ("targetings") {
          <app-sd-create-strategy-targetings [targetings]="creationForm.targetings" />
        }
        @case ("asins") {
          <app-sd-create-strategy-asins [asins]="creationForm.asins" />
        }
      }
    </div>
    <div shellFooter class="flex items-center justify-between gap-3">
      <button iButton variant="secondary" type="button" [disabled]="isCreatingStrategy()" (click)="cancel()">
        {{ t("common.cancel") }}
      </button>
      <div class="flex items-center gap-3">
        @if (!isFirstStep()) {
          <button iButton variant="secondary" type="button" [disabled]="isCreatingStrategy()" (click)="back()">
            {{ t("common.back") }}
          </button>
        }
        <button
          iButton
          type="button"
          [disabled]="!canGoNext() || (creationForm().invalid() && isLastStep())"
          [loading]="isCreatingStrategy()"
          [testId]="isLastStep() ? 'btn-create-strategy' : 'next-button'"
          (click)="next()"
        >
          {{
            isLastStep()
              ? isCreatingStrategy()
                ? t("common.creating_your_strategy")
                : t("sd-strategy-creation.create_strategy")
              : t("common.next")
          }}
        </button>
      </div>
    </div>
  </app-form-shell>
</div>
